import DeviceStorage from '../DeviceStorage/DeviceStorage';
import getAppConfig from '../../config/appConfig';
import Utils from '../../utils/Utils';
import pkg from '../../../package.json';

let instance = null;
class AnalyticsDimensionSingleton {
    constructor(user) {
        if (!instance) instance = this;
        this.user = user;
        return instance;
    }

    setUser(user) {
        this.user = user;
    }

    /**
     * Get generic payload for pageview events
     * 
     * @return {Object} Google Analytics payload
     */
    getPayload() {
        return {
            page: this.getPage(),
            hitType: "pageview",
            dimension1: this.getCountry(),
            dimension2: this.getClientId(),
            dimension3: this.getUserId(),
            dimension5: this.getUserType(),
            dimension6: this.getDevice(),
            dimension7: this.getVersion(),
            dimension8: this.getDeviceBrand(),
            dimension9: this.getParentId(),
        };
    }

    /**
     * Get the country the app is running in.
     * 
     * @return {string} Country
     */
    getCountry() {
        return Utils.getAbbreviation(DeviceStorage.getItem('region'));
    }

    /**
     * Get the device the app is running in.
     * 
     * @return {string} Device name
     */
    getDevice() {
        const deviceCategory = getAppConfig().device_category;
        if (
            deviceCategory === 'stb' &&
            getAppConfig().device_manufacturer === 'nagra'
        )
            return 'nagra';
        else if (deviceCategory === 'stb') return 'coship';
        else if (deviceCategory === 'tv') return 'stv';
        else if (deviceCategory === 'console') return 'ps4';
        else return deviceCategory;
    }

    /**
     * Get the type of user with subscriptions
     * 
     * @return {string} Get the type of user with it's subscriptions
     */
    getUserType() {
        let userType;
        if (this.user !== undefined) {
            switch (this.user.userStatus) {
                case 'susc':
                    userType = 'Suscrito';
                    break;
                case 'no_susc':
                    userType = 'Registrado';
                    break;
                default:
                    userType = 'Anonimo';
            }

            if (
                userType !== 'Anonimo' &&
                typeof this.user.subscriptions !== 'undefined'
            ) {
                const paywayProfileExists =
                    this.user.paywayProfile &&
                    this.user.paywayProfile.subscriptions &&
                    Array.isArray(this.user.paywayProfile.subscriptions);
                if (paywayProfileExists) {
                    if (
                        this.user.paywayProfile.subscriptions.filter(
                            item => item.key === 'Telmexmexico_abono_FOX_PLUS'
                        ).length !== 0
                    ) {
                        userType += '+foxplus';
                    } else if (this.user.subscriptions.FOX) userType += '+fox';
                }
                if (this.user.subscriptions.HBO) userType += '+hbo';
                if (this.user.subscriptions.NOGGIN) userType += '+noggin';
                if (this.user.subscriptions.CRACKLE) userType += '+crackle';
                if (this.user.subscriptions.PARAMOUNT) userType += '+paramount';
            }
        }

        return userType;
    }

    /**
     * Get the user id
     * 
     * @return {string} User id
     */
    getUserId() {
        const id =
            typeof this.user !== 'undefined'
                ? typeof this.user.parent_id !== 'undefined'
                    ? this.user.parent_id
                    : ''
                : '';
        return this.user && this.user.admin ? id : '';
    }

    /**
     * Get the parent id of the user
     * 
     * @return {string} Parent id
     */
    getParentId() {
        return this.user && this.user.parent_id && this.user.user_id
            ? this.user.parent_id + ',' + this.user.user_id
            : '';
    }

    /**
     * Get the page sent to GA. This is analogous to the current page
     * 
     * @return {string} Page URL
     */
    getPage() {
        return window.location.toString();
    }

    /**
     * Get the app version sent tto GA.
     * 
     * @return {string} App version
     */
    getVersion() {
        return pkg.version || 'v0';
    }

    /**
     * Get the brand of the current device
     * 
     * @return {string} Device brand
     */
    getDeviceBrand() {
        return `${getAppConfig().device_manufacturer} ${
            getAppConfig().device_model
        }`;
    }

    /**
     * Get the ID of the current client. This is unique for every device
     * and it's assigned on a per-session basis.
     * 
     * @return {string}
     */
    getClientId() {
        return getAppConfig().UniqueID;
    }
}

export default AnalyticsDimensionSingleton;



// WEBPACK FOOTER //
// ./src/components/Header/AnalyticsDimensionSingleton.js